import {
    ArrowRightSvg,
    IntelligentProSvg,
    SelfPlanSvg,
    WorkflowSvg,
    KnowledgeBaseSvg,
    FullChainSvg,
    ErnieIconSvg,
    VerticalModelSvg,
    OthersModelAvg,
    DateBuilder1Svg,
    DateBuilder2Svg,
    DateBuilder3Svg,
    DateBuilder4Svg,
    successCases6Svg,
    successCases5Svg,
    successCases4Svg,
    successCases3Svg,
    successCases2Svg,
    successCases1Svg,
} from 'assets/qf/iconSvg';

export const moduleTitleCn = 'qf-module-title';
export const moduleDescCn = 'qf-module-desc';
export const moduleContentCn = 'qf-module-content';

export const banner = {
    bannerBg: require('assets/qf/banner/banner.png').default,
    bannerBg_m: require('assets/qf/banner/banner_m.png').default,
    swiperList: [
        {
            id: 0,
            slideName: 'swiper1',
            title: '千帆大模型平台',
            bannerBg: require('assets/qf/banner/banner.png').default,
            bannerBg_m: require('assets/qf/banner/banner_m.png').default,
            noticeList: [
                {
                    id: 0,
                    icon: require('../../assets/qf/banner/notice-icon.png').default,
                    afterIcon: ArrowRightSvg,
                    desc: '百度千帆Coding Plan全面开放使用！',
                    link: 'https://cloud.baidu.com/product/codingplan.html',
                    trackInfo: {
                        'data-track-category': '千帆官网-banner',
                        'data-track-name': '文字链',
                        'data-track-value': '百度千帆Coding Plan全面开放使用！',
                    },
                },
            ],
            desc: '以Agent为核心的一站式企业级大模型服务平台',
            btnList: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/overview',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-banner',
                        'data-track-name': '横幅第1个按钮第1个',
                        'data-track-value': '立即体验',
                    },
                },
                // {
                //     text: '应用开发',
                //     link: 'https://console.bce.baidu.com/ai_apaas/appCenter',
                //     type: 'normal',
                //     trackInfo: {
                //         'data-track-category': '千帆官网-banner',
                //         'data-track-name': '横幅第1个按钮第2个',
                //         'data-track-value': '应用开发',
                //     },
                // },
            ],
        },
        // {
        //     id: 1,
        //     slideName: 'no-notice',
        //     title: 'Agent引擎',
        //     title_ipad: 'Agent引擎',
        //     title_m: 'Agent引擎',
        //     bannerBg: require('assets/qf/banner/banner3.png').default,
        //     bannerBg_m: require('assets/qf/banner/banner_m3.png').default,
        //     // noticeList: [
        //     //     {
        //     //         id: 0,
        //     //         icon: require('../../assets/qf/banner/notice-icon.png').default,
        //     //         afterIcon: ArrowRightSvg,
        //     //         desc: 'AI视频笔记等优质组件能力上线千帆！',
        //     //         link: 'https://console.bce.baidu.com/ai_apaas/componentCenter',
        //     //         trackInfo: {
        //     //             'data-track-category': '千帆官网-banner',
        //     //             'data-track-name': '文字链',
        //     //             'data-track-value': 'AI视频笔记等优质组件能力上线千帆！'
        //     //         }
        //     //     }
        //     // ],
        //     desc: '可定制、可扩展的智能服务框架，搭载精选MCP灵活调度，助力企业在多场景下高效构建与部署Agent服务',
        //     btnList: [
        //         {
        //             text: '立即体验',
        //             link: 'https://console.bce.baidu.com/qianfan/studio/examplePage/aiAssistant',
        //             target: '_blank',
        //             type: 'primary',
        //             trackInfo: {
        //                 'data-track-category': '千帆官网-banner',
        //                 'data-track-name': '横幅第2个按钮第1个',
        //                 'data-track-value': '立即体验'
        //             }
        //         }
        //     ]
        // },
        {
            id: 1,
            slideName: 'swiper2',
            title: '"多智能体协同Agent"全新升级',
            title_ipad: (
                <>
                    "多智能体协同Agent"
                    <br />
                    全新升级
                </>
            ),
            title_m: (
                <>
                    "多智能体协同Agent"
                    <br />
                    全新升级
                </>
            ),
            bannerBg: require('assets/qf/banner/banner2.png').default,
            bannerBg_m: require('assets/qf/banner/banner_m2.jpg').default,
            noticeList: [
                {
                    id: 0,
                    icon: require('../../assets/qf/banner/notice-icon.png').default,
                    afterIcon: ArrowRightSvg,
                    desc: 'AI视频笔记等优质组件能力上线千帆！',
                    link: 'https://console.bce.baidu.com/ai_apaas/componentCenter',
                    trackInfo: {
                        'data-track-category': '千帆官网-banner',
                        'data-track-name': '文字链',
                        'data-track-value': 'AI视频笔记等优质组件能力上线千帆！',
                    },
                },
            ],
            desc: '协调者-工作者动态编排模式、官方预置多种高质量agents、全面兼容A2A协议',
            btnList: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/personalSpace/app ',
                    target: '_blank',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-banner',
                        'data-track-name': '横幅第2个按钮第1个',
                        'data-track-value': '立即体验',
                    },
                },
            ],
        },
        // {
        //     id: 2,
        //     slideName: 'swiper3',
        //     title: '百度AI搜索',
        //     bannerBg: require('assets/qf/banner/banner4.png').default,
        //     bannerBg_m: require('assets/qf/banner/banner_m4.png').default,
        //     noticeList: [
        //         {
        //             id: 0,
        //             icon: require('../../assets/qf/banner/notice-icon.png').default,
        //             afterIcon: ArrowRightSvg,
        //             desc: 'AI搜索免费课程',
        //             link: 'https://cloud.baidu.com/partner/training-camp/33goak8qb9k.html',
        //             trackInfo: {
        //                 'data-track-category': '千帆官网-banner',
        //                 'data-track-name': '文字链',
        //                 'data-track-value': 'AI搜索免费课程',
        //             },
        //         },
        //     ],
        //     desc: '基于百度搜索能力与AI技术，专为生成式AI提供全网实时信息检索服务，具备海量内容站点、高权威性，强时效性，提供全新的搜索体验',
        //     btnList: [
        //         {
        //             text: '免费体验',
        //             link: 'https://console.bce.baidu.com/ai_apaas/aiSearchPage/detail',
        //             type: 'primary',
        //             trackInfo: {
        //                 'data-track-category': '千帆官网-banner',
        //                 'data-track-name': '横幅第3个按钮第1个',
        //                 'data-track-value': '免费体验',
        //             },
        //         },
        //         {
        //             text: '了解详情',
        //             link: 'https://cloud.baidu.com/product/ai-search.html?track=home-carousel-campaign-2',
        //             type: 'normal',
        //             trackInfo: {
        //                 'data-track-category': '千帆官网-banner',
        //                 'data-track-name': '横幅第3个按钮第2个',
        //                 'data-track-value': '了解详情',
        //             },
        //         },
        //     ],
        //     // tagList: [
        //     //     {
        //     //         title: '搜索内容',
        //     //         des: '权威、全面、高质',
        //     //     },
        //     //     {
        //     //         title: '搜索能力',
        //     //         des: '开放升级',
        //     //     },
        //     //     {
        //     //         title: '企业级',
        //     //         des: '高可用保障',
        //     //     },
        //     // ],
        // },
    ],
};

export const agent = {
    title: '构建企业级Agent',
    className: 'agent',
    tabsNav: [
        {
            icon: IntelligentProSvg,
            label: '多智能体协同Agent',
            value: 'agent1',
        },
        {
            icon: SelfPlanSvg,
            label: '自主规划Agent',
            value: 'agent2',
        },
        {
            icon: WorkflowSvg,
            label: '工作流Agent',
            value: 'agent3',
        },
        {
            icon: KnowledgeBaseSvg,
            label: '知识库RAG',
            value: 'agent4',
        },
        {
            icon: FullChainSvg,
            label: '全链路可观测',
            value: 'agent5',
        },
    ],
    content: {
        agent1: {
            title: '多智能体协同Agent',
            icon: require('../../assets/qf/agent/check.svg').default,
            bg: require('../../assets/qf/agent/agent_bg1.png').default,
            m_bg: require('../../assets/qf/agent/agent_bg1_m.png').default,
            descArr: [
                {
                    tit: '复杂任务下多智能体协同',
                    des: 'Multi-Agent编排引擎实现复杂场景下的任务智能分发和多Agent协同',
                },
                {
                    tit: '突破单一Agent效率瓶颈',
                    des: '高并发 DAG 执行引擎提升效率，支持全链路流式输出，任务进度实时跟随',
                },
                {
                    tit: '官方预置高质量子Agent',
                    des: '预置网页探索、代码编写、报告撰写等Agent，开箱即用',
                },
                {
                    tit: '全面兼容A2A协议',
                    des: '全面兼容A2A协议，打造更开放的Agent生态',
                },
            ],
            btns: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/personalSpace/app',
                    target: '_target',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-企业级Agent',
                        'data-track-name': '多智能体协同Agent',
                        'data-track-value': '立即体验',
                    },
                },
            ],
            videoId: 'tab1VideoId',
            videoId_m: 'tab1VideoId_m',
            rightVideo: require('../../assets/qf/agent/tab1_video.mp4').default,
            video_poster: require('../../assets/qf/agent/tab1_video_poster.png').default,
            rightVideo_m: require('../../assets/qf/agent/tab1_mobile.mp4').default,
            video_poster_m: require('../../assets/qf/agent/tab1_video_poster_m.png').default,
        },
        agent2: {
            title: '自主规划Agent',
            bg: require('assets/qf/agent/agent_bg1.png').default,
            m_bg: require('assets/qf/agent/agent_bg1_m.png').default,
            descArr: [
                {
                    tit: '低门槛快速打造多模态Agent',
                    des: '精准自主规划能力、多模态交互模式、灵活的策略配置以及丰富的预置工具',
                },
                {
                    tit: '智能记忆提供个性化服务',
                    des: '强大记忆能力，智能记忆用户偏好与关键信息，持续提供个性化服务',
                },
                {
                    tit: '打造专属数字人形象与声音',
                    des: '支持语音互动、定制化AI声线与形象，打造品牌专属数字助手',
                },
            ],
            btns: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/personalSpace/app',
                    target: '_target',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-企业级Agent',
                        'data-track-name': '自主规划Agent',
                        'data-track-value': '立即体验',
                    },
                },
            ],
            rightVideo: require('assets/qf/agent/tab2_video.mp4').default,
            video_poster: require('assets/qf/agent/tab2_video_poster.png').default,
            rightVideo_m: require('assets/qf/agent/tab2_mobile.mp4').default,
            video_poster_m: require('assets/qf/agent/tab2_video_poster_m.png').default,
        },
        agent3: {
            title: '工作流Agent',
            bg: require('assets/qf/agent/agent_bg3.png').default,
            m_bg: require('assets/qf/agent/agent_bg3_m.png').default,
            descArr: [
                {
                    tit: '精准编排企业真实业务流',
                    des: '可视化画布式灵活编排，还原真实企业业务流，稳定可控的效果输出',
                },
                {
                    tit: '节点丰富且灵活开放',
                    des: '节点丰富且适配性强，可快速将企业系统API接入，实现能力无限拓展',
                },
                {
                    tit: '独有的全局跳转节点',
                    des: '独有的全局跳转节点，及时将对话拉回原流程，高效化解模糊询问回复难题',
                },
            ],
            btns: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/personalSpace/app',
                    target: '_target',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-构建企业级Agent',
                        'data-track-name': '工作流Agent',
                        'data-track-value': '立即体验',
                    },
                },
            ],
            // rightBg: require('assets/qf/agent/right-bg3.png').default,
            rightVideo: require('../../assets/qf/agent/tab3_video.mp4').default,
            video_poster: require('../../assets/qf/agent/tab3_video_poster.png').default,
            rightVideo_m: require('../../assets/qf/agent/tab3_mobile.mp4').default,
            video_poster_m: require('../../assets/qf/agent/tab3_video_poster_m.png').default,
        },
        agent4: {
            title: '知识库RAG',
            bg: require('assets/qf/agent/agent_bg4.png').default,
            m_bg: require('assets/qf/agent/agent_bg4_m.png').default,
            descArr: [
                {
                    tit: '领先的企业级知识库',
                    des: '支持多源、异构、多模态数据一体化解析，提供稳定高效的向量存储与检索服务',
                },
                {
                    tit: '高质量的内容召回',
                    des: '依托丰富的解析、切片、检索策略，结合知识增强与知识图谱，显著提升内容召回准确率与召回率',
                },
                {
                    tit: '灵活的RAG配置',
                    des: '无缝对接智能体与工作流，轻松构建Agent',
                },
            ],
            btns: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/personalSpace/knowledgeBase',
                    target: '_target',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-构建企业级Agent',
                        'data-track-name': '知识库RAG',
                        'data-track-value': '立即体验',
                    },
                },
            ],
            // rightBg: require('assets/qf/agent/right-bg4.png').default,
            rightVideo: require('../../assets/qf/agent/tab4_video.mp4').default,
            video_poster: require('../../assets/qf/agent/tab4_video_poster.png').default,
            rightVideo_m: require('../../assets/qf/agent/tab4_mobile.mp4').default,
            video_poster_m: require('../../assets/qf/agent/tab4_video_poster_m.png').default,
        },
        agent5: {
            title: '全链路可观测',
            bg: require('assets/qf/agent/agent_bg5.png').default,
            m_bg: require('assets/qf/agent/agent_bg5_m.png').default,
            descArr: [
                {
                    tit: '全链路可视化诊断分析',
                    des: '可视化展示单次请求或操作‌在 Agent 中的‌完整执行路径‌，迅速定位问题',
                },
                {
                    tit: '开发环节快速Debug调优',
                    des: '深度集成至Agent开发环节，帮助开发者根因分析，提升debug效果',
                },
                {
                    tit: '投产环节持续监控保障',
                    des: '快速定位慢查询与异常节点，探寻性能瓶颈，根因分析与快速排障无忧',
                },
            ],
            btns: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/trace',
                    target: '_target',
                    // type: 'disabled',
                    trackInfo: {
                        'data-track-category': '千帆官网-构建企业级Agent',
                        'data-track-name': '全链路可观测',
                        'data-track-value': '立即体验',
                    },
                },
            ],
            // rightBg: require('assets/qf/agent/right-bg5.png').default,
            rightVideo: require('../../assets/qf/agent/tab5_video.mp4').default,
            video_poster: require('../../assets/qf/agent/tab5_video_poster.png').default,
            rightVideo_m: require('../../assets/qf/agent/tab5_mobile.mp4').default,
            video_poster_m: require('../../assets/qf/agent/tab5_video_poster_m.png').default,
        },
    },
    application: {
        title: '精选Agent应用',
        list: [
            {
                icon: require('../../assets/qf/agent/exp-icon1.png').default,
                title: '专业考题深度解析助教',
                tag: ['百度搜索', '教育培训', '自主规划Agent'],
                desc: '充分发挥百度搜索能力优势，针对输入的专业考试试题与答案，给出解析过程，提高老师教学效率',
                btns: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/examplePage/c53897af-877d-4643-b1ae-4546243fcfa6',
                    trackInfo: {
                        'data-track-category': '千帆官网-构建企业级Agent-精选Agent应用',
                        'data-track-name': '专业考题深度解析助教',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                icon: require('../../assets/qf/agent/exp-icon2.png').default,
                title: '车险续保金牌销售',
                tag: ['拟人对话', '营销电商', '工作流Agent'],
                desc: '还原真实的车险销售业务流程，超高对话拟人度，灵活化解客户拒绝态度，推动客户完成续保',
                btns: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/examplePage/2f154d2a-d617-4133-a1bf-b458277442c4',
                    trackInfo: {
                        'data-track-category': '千帆官网-构建企业级Agent-精选Agent应用',
                        'data-track-name': '车险续保金牌销售',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                icon: require('../../assets/qf/agent/exp-icon3.png').default,
                title: '古诗小伴读',
                tag: ['实时对话', '教育培训', '自主规划Agent'],
                desc: '支持实时语音交互对话，提供小度米朵可爱女声陪伴孩子学习快乐成长，开启古诗伴读启蒙',
                btns: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/examplePage/4fb80a78-bc95-4b17-a61f-dd8660232553',
                    trackInfo: {
                        'data-track-category': '千帆官网-构建企业级Agent-精选Agent应用',
                        'data-track-name': '古诗小伴读',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                icon: require('../../assets/qf/agent/exp-icon4.png').default,
                title: '电力知识库助手',
                tag: ['知识库RAG', '政务服务', '自主规划Agent'],
                desc: '构建电力专业知识库，精准查询电力相关知识，既能服务企业员工，也可解答居民用电问题',
                btns: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/ai_apaas/examplePage/b490ec71-2480-4ac9-9748-91e77902e239',
                    trackInfo: {
                        'data-track-category': '千帆官网-构建企业级Agent-精选Agent应用',
                        'data-track-name': '电力知识库助手',
                        'data-track-value': '立即体验',
                    },
                },
            },
        ],
    },
    // bottonBtn: {
    //     text: '探索更多大模型',
    //     link: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/list',
    //     trackInfo: {
    //         'data-track-category': '千帆官网-构建企业级Agent-精选Agent应用',
    //         'data-track-name': '电力知识库助手',
    //         'data-track-value': '立即体验'
    //     }
    // }
};

export const modelsService = {
    title: '高效价比的模型服务',
    onlineTest: {
        placeholder: '请输入问题，例如请帮我做一份北京7天的旅行规划。',
        selectOptions: [
            {
                label: 'ernie-5.0-thinking-preview',
                icon: require('../../assets/qf/models/ernie.png').default,
                link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/multimodal/ERNIE-5.0-Thinking-Preview',
            },
            {
                label: 'ERNIE X1.1 Preview',
                icon: require('../../assets/qf/models/ernie.png').default,
                link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/ERNIE-X1.1-Preview',
            },
            {
                label: 'ERNIE 4.5 Turbo',
                icon: require('assets/qf/models/ernie.png').default,
                link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/ERNIE-4.5-Turbo-128K',
            },
            {
                label: 'DeepSeek-V3.1-Think',
                icon: require('assets/qf/models/deepseek.png').default,
                link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/DeepSeek-V3.1-Think-250821',
            },
            {
                label: 'DeepSeek-V3.1',
                icon: require('assets/qf/models/deepseek.png').default,
                link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/DeepSeek-V3.1-250821',
            },
        ],
    },
    tabsNav: [
        {
            icon: ErnieIconSvg,
            label: '自研通用模型',
            value: 'model1',
        },
        {
            icon: VerticalModelSvg,
            label: '垂类场景模型',
            value: 'model2',
        },
        {
            icon: OthersModelAvg,
            label: '第三方模型',
            value: 'model3',
        },
    ],
    content: {
        model1: [
            {
                name: '百度蒸汽机2.0',
                icon: require('../../assets/qf/models/ernie.png').default,
                desc: '通过多模态信息精准同步与自然交互，支持多人对话音视频一体化生成，音画同步，电影级质感画面、大师级运镜，中文语音细节高度还原。',
                modelType: 'video',
                tags: [
                    {
                        label: '音视一体，画质革命',
                        type: 'primary',
                    },
                ],
                type: [
                    {
                        label: '视频生成',
                        type: '',
                    },
                ],
                accessPoint: 'musesteamer-2.0-turbo-i2v-audio',
                context: '-',
                price: {
                    input: '¥1.4 / 5s、 ¥2.8 / 10s',
                    output: '¥2.5 / 5s、 ¥4.2 / 10s',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/video/MuseSteamer-2.0-Turbo-I2V-Audio',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': '百度蒸汽机2.0',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'ERNIE X1.1 Preview',
                icon: require('../../assets/qf/models/ernie.png').default,
                desc: '问答、工具调用、智能体、指令遵循、逻辑推理、数学、代码任务的效果显著提升，事实性显著提升。支持64K上下文长度，兼顾响应速度与长链路推理连贯性。',
                tags: [
                    {
                        label: '全新升级，效果提升',
                        type: 'primary',
                    },
                ],
                type: [
                    {
                        label: '深度推理',
                        type: '',
                    },
                ],
                accessPoint: 'ernie-x1.1-preview',
                context: '64k,55K+64K',
                price: {
                    input: '¥0.001/ 千tokens',
                    output: '¥0.004/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/ERNIE-X1.1-Preview',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'ERNIE X1.1 Preview',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'ERNIE 4.5 Turbo VL',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '图片理解、创作、翻译、代码等能力显著提升，支持128K上下文长度，首Token时延显著降低。',
                tags: [],
                type: [
                    {
                        label: '多模态',
                        type: '',
                    },
                    {
                        label: '图像理解',
                        type: '',
                    },
                ],
                accessPoint: 'ernie-4.5-turbo-vl',
                context: '128K,123K+ 16K',
                price: {
                    input: '¥0.003/ 千tokens',
                    output: '¥0.009/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/multimodal/ERNIE-4.5-Turbo-VL',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'ERNIE 4.5 Turbo VL',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'ERNIE 4.5 Turbo',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '文心4.5 Turbo在去幻觉、逻辑推理和代码能力等方面也有着明显增强。对比文心4.5，速度更快、价格更低。',
                tags: [],
                type: [
                    {
                        label: '文本生成',
                        type: '',
                    },
                ],
                accessPoint: 'ernie-4.5-turbo-128k',
                context: '128K,123K+ 12K',
                price: {
                    input: '¥0.0008/ 千tokens',
                    output: '¥0.0032/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/ERNIE-4.5-Turbo-128K',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'ERNIE 4.5 Turbo',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'ERNIE-5.0-Thinking-Preview',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '文心5.0是原生全模态大模型，基础能力全面升级，多模态理解、指令遵循、创意写作、事实性、智能体规划与工具应用等表现尤其出色',
                tags: [],
                type: [
                    {
                        label: '深度推理',
                        type: '',
                    },
                    {
                        label: '视觉理解',
                        type: '',
                    },
                ],
                accessPoint: 'ernie-5.0-thinking-preview',
                context: '119k，64k',
                price: {
                    input: '¥0.006-0.01/ 千tokens',
                    output: '¥0.024-0.04/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/multimodal/ERNIE-5.0-Thinking-Preview',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'ERNIE-5.0-Thinking-Preview',
                        'data-track-value': '立即体验',
                    },
                },
            },
            // {
            //     name: 'ERNIE-4.5-21B-A3B',
            //     icon: require('assets/qf/models/ernie.png').default,
            //     desc: '文心4.5中的一款文本类 MoE 后训练开源模型，具备 210 亿总参数量，激活参数为 30 亿。',
            //     tags: [],
            //     type: [
            //         {
            //             label: '文本生成',
            //             type: '',
            //         },
            //     ],
            //     accessPoint: 'ernie-4.5-21b-a3b',
            //     context: '128K,120K+8K',
            //     price: {
            //         input: '¥0.0005/ 千tokens',
            //         output: '¥0.002/ 千tokens',
            //     },
            //     btn: {
            //         text: '立即体验',
            //         link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/ERNIE-4.5-21B-A3B',
            //     },
            // },
            {
                name: 'ERNIE-4.5-VL-28B-A3B',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '文心4.5中的多模态开源模型，采用MoE架构，具备 280 亿总参数量，激活参数为 30 亿，支持切换思考和非思考两种模式。',
                tags: [
                    {
                        label: '多模融合,全新升级',
                        type: 'primary',
                    },
                ],
                type: [
                    {
                        label: '多模态',
                        type: '',
                    },
                    {
                        label: '深度推理',
                        type: '',
                    },
                ],
                accessPoint: 'ernie-4.5-vl-28b-a3b',
                context: '32K,30K+8K',
                price: {
                    input: '¥0.001/ 千tokens',
                    output: '¥0.01/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/multimodal/ERNIE-4.5-VL-28B-A3B',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'ERNIE-4.5-VL-28B-A3B',
                        'data-track-value': '立即体验',
                    },
                },
            },
        ],
        model2: [
            {
                name: 'Qianfan-MultiPicOCR',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '针对教育场景有效识别并抽取多张图片信息内容并转换为yaml格式，可精准解析出题目标题、题目类型、答案、解析、标识等信息。',
                tags: [],
                type: [
                    {
                        label: '教育场景',
                        type: '',
                    },
                    {
                        label: '图像理解',
                        type: '',
                    },
                ],
                accessPoint: 'qianfan-multipicocr',
                context: '128k,96k+32k',
                price: {
                    input: '¥0.0025/ 千tokens',
                    output: '¥0.0075/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/image2text/Qianfan-MultiPicOCR',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Qianfan-MultiPicOCR',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'Qianfan-Composition',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '针对教育场景专注于从输入图片中识别作文相关内容，可精准提取作文标题，完整还原文本内容。',
                tags: [],
                type: [
                    {
                        label: '教育场景',
                        type: '',
                    },
                    {
                        label: '图像理解',
                        type: '',
                    },
                ],
                accessPoint: 'qianfan-composition',
                context: '32k,24k+8k',
                price: {
                    input: '¥0.0025/ 千tokens',
                    output: '¥0.0075/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/image2text/Qianfan-Composition',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Qianfan-Composition',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'Qianfan-Correct',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '本作文批改模型是一款聚焦日常作文批改场景，实现从分数评定到理由分析的智能服务，提升写作教学效率。',
                tags: [],
                type: [
                    {
                        label: '教育场景',
                        type: '',
                    },
                    {
                        label: '文本生成',
                        type: '',
                    },
                ],
                accessPoint: 'qianfan-correct',
                context: '4k,3K+1K',
                price: {
                    input: '¥0.0006/ 千tokens',
                    output: '¥0.006/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/Qianfan-Correct',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Qianfan-Correct',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'Qianfan-PublicOpinion-Classification',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '针对图片信息判断是否为敏感场景，如暴力事件、自然灾害、交通事故等，并严格按照json格式进行内容输出。',
                tags: [],
                type: [
                    {
                        label: '审核场景',
                        type: '',
                    },
                    {
                        label: '图像理解',
                        type: '',
                    },
                ],
                accessPoint: 'qianfan-publicopinion-classification',
                context: '28k，24k+4k',
                price: {
                    input: '¥0.0015/ 千tokens',
                    output: '¥0.0045/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/image2text/Qianfan-PublicOpinion-Classification',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Qianfan-PublicOpinion-Classification',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'Qianfan-ToyTalk',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '本玩具对话模型是一款面向低龄儿童的互动模型，对话逻辑简单清晰，回应内容浅显易懂且充满童趣，提供沉浸式角色扮演体验。',
                tags: [],
                type: [
                    {
                        label: '角色扮演',
                        type: '',
                    },
                    {
                        label: '文本生成',
                        type: '',
                    },
                ],
                accessPoint: 'qianfan-toytalk',
                context: '32k,28k+4k',
                price: {
                    input: '¥0.0001/ 千tokens',
                    output: '¥0.0002/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/Qianfan-ToyTalk',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Qianfan-ToyTalk',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'Qianfan-QI-VL',
                icon: require('assets/qf/models/ernie.png').default,
                desc: '适用于电商场景下对电商上传的商品图片进行质量检测，检测能力包含AIGC人体瑕疵检测、马赛克识别、水印识别和商标检测。',
                tags: [],
                type: [
                    {
                        label: '电商场景',
                        type: '',
                    },
                    {
                        label: '图像理解',
                        type: '',
                    },
                ],
                accessPoint: 'qianfan-qi-vl',
                context: '128k,124k+4k',
                price: {
                    input: '¥0.0015/ 千tokens',
                    output: '¥0.0045/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/image2text/Qianfan-QI-VL',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Qianfan-QI-VL',
                        'data-track-value': '立即体验',
                    },
                },
            },
        ],
        model3: [
            {
                name: 'DeepSeek-V3.1-Think',
                icon: require('assets/qf/models/deepseek.png').default,
                desc: 'DeepSeek-V3.1思考模式，相比DeepSeek-R1-0528拥有更高的思考效率。',
                tags: [
                    {
                        label: '旗舰模型,口碑之选',
                        type: 'primary',
                    },
                ],
                type: [
                    {
                        label: '深度推理',
                        type: '',
                    },
                ],
                accessPoint: 'deepseek-v3.1-think-250821',
                context: '128K，96K+48K',
                price: {
                    input: '¥0.004/ 千tokens',
                    output: '¥0.012/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/DeepSeek-V3.1-Think-250821',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'DeepSeek-V3.1-Think',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'DeepSeek-V3.1',
                icon: require('assets/qf/models/deepseek.png').default,
                desc: 'DeepSeek-V3.1非思考模式，拥有更强的Agent能力，在工具使用与智能体任务中的表现有较大提升。',
                tags: [],
                type: [
                    {
                        label: '文本生成',
                        type: '',
                    },
                ],
                accessPoint: 'deepseek-v3.1-250821',
                context: '128K,128K+16K',
                price: {
                    input: '¥0.004/ 千tokens',
                    output: '¥0.012/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/DeepSeek-V3.1-250821',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'DeepSeek-V3.1',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'Qwen3-Coder-480B-A35B-Instruct',
                icon: require('assets/qf/models/qwenwen.png').default,
                desc: '基于Qwen3的代码生成模型，具有强大的Coding Agent能力，代码能力达到开源模型 SOTA。',
                tags: [
                    {
                        label: '代码生成,灵活计费',
                        type: 'primary',
                    },
                ],
                type: [
                    {
                        label: '文本生成',
                        type: '',
                    },
                ],
                accessPoint: 'qwen3-coder-480b-a35b-instruct',
                context: '128K,128K+64K',
                price: {
                    input: '¥0.006-0.009/ 千tokens',
                    output: '¥0.024-0.036/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/Qwen3-Coder-480B-A35B-Instruct',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Qwen3-Coder-480B-A35B-Instruct',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'Kimi-K2-Instruct',
                icon: require('assets/qf/models/Kimi.svg').default,
                desc: '月之暗面提供的国内首个开源万亿参数MoE模型，具有 320 亿个激活参数和 1 万亿个总参数，具有卓越的编码和工具调用能力。',
                tags: [],
                type: [
                    {
                        label: '文本生成',
                        type: '',
                    },
                ],
                accessPoint: 'kimi-k2-instruct',
                context: '128K,128K+ 32K',
                price: {
                    input: '¥0.004/ 千tokens',
                    output: '¥0.016/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/chat/Kimi-K2-Instruct',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Kimi-K2-Instruct',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'Qwen2.5-VL-7B-Instruct',
                icon: require('assets/qf/models/qwenwen.png').default,
                desc: 'Qwen2.5-VL视觉语言模型具备强大的视觉理解能力，可分析图像中文本、图表和布局，支持视频理解、视觉定位，生成结构化输出。',
                tags: [],
                type: [
                    {
                        label: '视觉理解',
                        type: '',
                    },
                ],
                accessPoint: 'qwen2.5-vl-7b-instruct',
                context: '16K,12K+4K',
                price: {
                    input: '¥0.002/ 千tokens',
                    output: '¥0.005/ 千tokens',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/image2text/Qwen2.5-VL-7B-Instruct',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Qwen2.5-VL-7B-Instruct',
                        'data-track-value': '立即体验',
                    },
                },
            },
            {
                name: 'Qwen3-Embedding-4B',
                icon: require('assets/qf/models/qwenwen.png').default,
                desc: '基于 Qwen3 系列的密集基础模型，专门设计用于文本嵌入，可用于文本检索、代码检索、文本分类、文本聚类和双语文本挖掘。',
                tags: [],
                type: [
                    {
                        label: '向量表示',
                        type: '',
                    },
                ],
                accessPoint: 'qwen3-embedding-4b',
                context: '单条文本8k',
                price: {
                    input: '¥0.0005/千tokens',
                    output: '',
                },
                btn: {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/detail/am-64f3ddpkuqsu',
                    trackInfo: {
                        'data-track-category': '千帆官网-高效价比的模型服务',
                        'data-track-name': 'Qwen3-Embedding-4B',
                        'data-track-value': '立即体验',
                    },
                },
            },
        ],
    },
    bottomBtn: {
        text: '探索更多大模型',
        link: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/list',
        trackInfo: {
            'data-track-category': '千帆官网-高效价比的模型服务',
            'data-track-name': '',
            'data-track-value': '探索更多大模型',
        },
    },
};

export const dataBuilder = {
    title: '一站式数据智能平台DataBuilder',
    className: 'builder',
    tabsNav: [
        {
            icon: DateBuilder1Svg,
            label: '高效数据迭代',
            value: 'dataBuilder1',
        },
        {
            icon: DateBuilder2Svg,
            label: '多模态数据管理',
            value: 'dataBuilder2',
        },
        {
            icon: DateBuilder3Svg,
            label: '一站式高性能计算',
            value: 'dataBuilder3',
        },
        {
            icon: DateBuilder4Svg,
            label: '智能数据分析',
            value: 'dataBuilder4',
        },
    ],
    content: {
        dataBuilder1: {
            title: '高效数据迭代',
            bg: require('assets/qf/dataBuilder/bg1.png').default,
            m_bg: require('assets/qf/dataBuilder/m_bg1.png').default,
            descArr: [
                {
                    tit: '在线开发平台',
                    des: '同个工作空间多角色协作，支持在线文件系统等能力，提供统一的开发体验',
                },
                {
                    tit: '灵活任务编排',
                    des: '支持多任务可视化调度和分布式并行，便于用户完成复杂的数据开发工作',
                },
                {
                    tit: '优质算子增强',
                    des: '内置增强算子和高质量数据集，有助于提升开发效率和效果',
                },
                {
                    tit: 'Agent开发提效',
                    des: '自研AI智能引擎，支持通过自然语言指令生成开发代码，帮助用户高效完成代码任务',
                },
            ],
            btns: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/edap/#?from=db',
                    target: '_blank',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-一站式数据智能平台DataBuilder',
                        'data-track-name': '高效数据迭代',
                        'data-track-value': '立即体验',
                    },
                },
            ],
            rightBg: require('assets/qf/dataBuilder/right-bg1.png').default,
        },
        dataBuilder2: {
            title: '多模态数据管理',
            bg: require('assets/qf/dataBuilder/bg2.png').default,
            m_bg: require('assets/qf/dataBuilder/m_bg2.png').default,
            descArr: [
                {
                    tit: '统一管理',
                    des: '整合多种数据源，统一管理结构和非结构化数据',
                },
                {
                    tit: '智能数据治理',
                    des: '内置质量规则库，结合大模型能力，对数据质量进行智能评估和自动修复',
                },
                {
                    tit: '企业级数据安全',
                    des: '支持数据加密、权限管理和操作审计，满足企业数据合规要求',
                },
            ],
            btns: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/edap/#?from=db',
                    target: '_blank',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-一站式数据智能平台DataBuilder',
                        'data-track-name': '多模态数据管理',
                        'data-track-value': '立即体验',
                    },
                },
            ],
            rightBg: require('assets/qf/dataBuilder/right-bg2.png').default,
        },
        dataBuilder3: {
            title: '一站式高性能计算',
            bg: require('assets/qf/dataBuilder/bg3.png').default,
            m_bg: require('assets/qf/dataBuilder/m_bg3.png').default,
            descArr: [
                {
                    tit: '多计算引擎协同',
                    des: '支持各类大数据和AI引擎，多引擎协同计算，保障大规模并发任务调度执行',
                },
                {
                    tit: '异构加速支持',
                    des: '提供GPU、CPU异构算力，大幅提升资源利用效率，数据读写速度显著加快',
                },
            ],
            btns: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/edap/#?from=db',
                    target: '_blank',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-一站式数据智能平台DataBuilder',
                        'data-track-name': '一站式高性能计算',
                        'data-track-value': '立即体验',
                    },
                },
            ],
            rightBg: require('assets/qf/dataBuilder/right-bg3.png').default,
        },
        dataBuilder4: {
            title: '智能数据分析',
            bg: require('assets/qf/dataBuilder/bg4.png').default,
            m_bg: require('assets/qf/dataBuilder/m_bg4.png').default,
            descArr: [
                {
                    tit: 'AI Search',
                    des: '内置智能搜索，支持检索文档、图片、视频等多模态数据，通过语义理解能力，让搜索结果更准确',
                },
                {
                    tit: '数据洞察',
                    des: '帮助用户海量数据中提取和探索数据特征，并通过可视化图表和文本描述来直观表达数据见解',
                },
            ],
            btns: [
                {
                    text: '立即体验',
                    link: 'https://console.bce.baidu.com/edap/#?from=db',
                    target: '_blank',
                    type: 'primary',
                    trackInfo: {
                        'data-track-category': '千帆官网-一站式数据智能平台DataBuilder',
                        'data-track-name': '智能数据分析',
                        'data-track-value': '立即体验',
                    },
                },
            ],
            rightBg: require('assets/qf/dataBuilder/right-bg4.png').default,
        },
    },
};

export const componentsAndMCPServices = {
    title: '独家优质组件与精选MCP服务',
    btnText: '探索更多组件',
    link: 'https://console.bce.baidu.com/ai_apaas/componentCenter',
    trackInfo: {
        'data-track-category': '千帆官网-独家优质组件与精选MCP服务',
        'data-track-name': '',
        'data-track-value': '探索更多组件',
    },
    cardItems: [
        {
            icon: require('assets/qf/componentsAndMCPServices/logo1.png').default,
            name: '百度搜索',
            description: '百度搜索是利用百度搜索引擎查找相关信息的组件，它会直接输出用户的搜索内容。',
            tags: ['独家', 'MCP'],
            freeCalls: '100次/天',
            link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/web_search/detail',
            trackInfo: {
                'data-track-category': '千帆官网-独家优质组件与精选MCP服务',
                'data-track-name': '百度搜索',
                'data-track-value': '立即体验',
            },
        },
        {
            icon: require('assets/qf/componentsAndMCPServices/logo2.png').default,
            name: '智能搜索生成',
            description: '百度搜索基础上提供大模型内容总结，支持图文输入处理、改写扩写增强、自定义安全策略等能力。',
            tags: ['独家', 'MCP'],
            freeCalls: '100次/天',
            link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/baidu_ai_search/detail',
            trackInfo: {
                'data-track-category': '千帆官网-独家优质组件与精选MCP服务',
                'data-track-name': '智能搜索生成',
                'data-track-value': '立即体验',
            },
        },
        {
            icon: require('assets/qf/componentsAndMCPServices/logo3.png').default,
            name: '百度百科',
            description: '百度百科（BaiduBaike）可根据某个具体的词条内容或者词条id检索到相关百科网页源内容。',
            tags: ['独家', '网页搜索'],
            freeCalls: '100次/天',
            link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/baidu_baike/detail',
            trackInfo: {
                'data-track-category': '千帆官网-独家优质组件与精选MCP服务',
                'data-track-name': '百度百科',
                'data-track-value': '立即体验',
            },
        },
        {
            icon: require('assets/qf/componentsAndMCPServices/logo4.png').default,
            name: '秒懂百科',
            description: '秒懂百科（EncyclopediaVideos）可以根据百科词条名、词条id检索相关的视频。',
            tags: ['独家', '网页搜索'],
            freeCalls: '100次/天',
            link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/miao_dong_baike/detail',
            trackInfo: {
                'data-track-category': '千帆官网-独家优质组件与精选MCP服务',
                'data-track-name': '秒懂百科',
                'data-track-value': '立即体验',
            },
        },
        {
            icon: require('assets/qf/componentsAndMCPServices/logo5.png').default,
            name: '通用文字识别',
            description: '支持网络图片、办公文档、表格、手写体、二维码、印章等全类型文字提取，并结构化识别。',
            tags: ['独家', 'MCP'],
            freeCalls: '1QPS',
            link: 'https://console.bce.baidu.com/ai_apaas/mcpServerCenter/mcp_server_aip_ocr_general/detail',
            trackInfo: {
                'data-track-category': '千帆官网-独家优质组件与精选MCP服务',
                'data-track-name': '通用文字识别',
                'data-track-value': '立即体验',
            },
        },
        {
            icon: require('assets/qf/componentsAndMCPServices/logo6.png').default,
            name: '网页内容总结',
            description: '网页内容总结（WebSummary），访问网页内容，满足网页总结、问答等诉求。',
            tags: ['实用工具'],
            freeCalls: '1QPS',
            link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/web_summary/detail',
            trackInfo: {
                'data-track-category': '千帆官网-独家优质组件与精选MCP服务',
                'data-track-name': '网页内容总结',
                'data-track-value': '立即体验',
            },
        },
        {
            icon: require('assets/qf/componentsAndMCPServices/logo7.png').default,
            name: '长文档内容理解',
            description: '对字符10万字内、文档大小20MB内的长文档进行解析，支持信息检索、摘要总结、文本分析能力。',
            tags: ['文本处理'],
            freeCalls: '1QPS',
            link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/document_understanding/detail',
            trackInfo: {
                'data-track-category': '千帆官网-独家优质组件与精选MCP服务',
                'data-track-name': '长文档内容理解',
                'data-track-value': '立即体验',
            },
        },
        {
            icon: require('assets/qf/componentsAndMCPServices/logo8.png').default,
            name: '百度地图',
            description: '百度地图组件提供了丰富的出行能力，例如地点检索、路线规划、正逆地理编码、天气查询等。',
            tags: ['独家', 'MCP', '生活助手'],
            freeCalls: '',
            link: 'https://console.bce.baidu.com/ai_apaas/mcpServerCenter/mcp_server_baidu_map/detail',
            trackInfo: {
                'data-track-category': '千帆官网-独家优质组件与精选MCP服务',
                'data-track-name': '百度地图',
                'data-track-value': '立即体验',
            },
        },
    ],
};

export const enterpriseLevelCloudNativeHighAvailability = {
    title: '企业级云原生高可用',
    cards: [
        [
            {
                icon: require('assets/qf/enterpriseLevelCloudNativeHighAvailability/icon1.svg').default,
                title: '多维监控',
                subTitle: '为企业稳定使用保驾护航',
                desc: '提供全局调用/异常分析/ Agent 资源统计等 20+ 丰富监控指标',
            },
            {
                icon: require('assets/qf/enterpriseLevelCloudNativeHighAvailability/icon2.svg').default,
                title: '审计合规',
                subTitle: '满足企业合规性需求',
                desc: '控制台与管控API核心事件接入云审计BCT，对操作进行详细的审计记录',
            },
        ],
        [
            {
                icon: require('assets/qf/enterpriseLevelCloudNativeHighAvailability/icon3.svg').default,
                title: '日志持久化',
                subTitle: '满足企业日志管理诉求',
                desc: '可投递至云BLS日志服务，持久化管理与存储，并支持回流、脱敏与挖掘',
            },
            {
                icon: require('assets/qf/enterpriseLevelCloudNativeHighAvailability/icon4.svg').default,
                title: '安全能力',
                subTitle: '避免企业业务风险',
                desc: '针对模型输入输出提供独家安全策略，并支持自定义干预，满足合规要求',
            },
        ],
        [
            {
                icon: require('assets/qf/enterpriseLevelCloudNativeHighAvailability/icon5.svg').default,
                title: '实时告警',
                subTitle: '为企业提供及时告警推送',
                desc: '无缝接入云监控BCM，可配置自定义告警规则及通知渠道',
            },
            {
                icon: require('assets/qf/enterpriseLevelCloudNativeHighAvailability/icon6.svg').default,
                title: '权限管控',
                subTitle: '提升企业操作安全性',
                desc: '支持多用户访问控制与自定义细粒度权限策略，支持主账户对子用户管控',
            },
        ],
    ],
    subTitle: '安全、稳定高可用',
};

export const successCases = {
    title: '客户成功落地案例',
    casesItem: [
        {
            icon: successCases1Svg,
            name: '政务企服',
            card: [
                {
                    name: '智能 “居民助理” 带来政务服务新变革',
                    introduction:
                        '基于RAG 框架构建本地政务知识库，并运用文心大模型能力开发“居民助理”，可通过语音或文本方式响应居民医保缴费、户籍办理等咨询，并将居民诉求转换为工单并进入后台流转。',
                    benefits: ['20万户+|居民触达', '70%|服务满意度', '7*24小时|便民服务'],
                    bg: require('assets/qf/successCases/bg_anli_zhengwu01.png').default,
                },
                {
                    name: '助力中华全国总工会系统服务效率跃迁式提升',
                    introduction:
                        '千帆通过建设一套 1+4+N 的人工智能应用支撑体系，实现了全国一盘棋，服务全国亿万职工会员，提供更人性、高效、准确的法律和维权服务，得到有效信息支撑从周级到小时级。',
                    benefits: ['亿万职工|获得援助服务', '小时级|获取有效信息', '1个月内|系统完成交付'],
                    bg: require('assets/qf/successCases/bg_anli_zhengwu02.png').default,
                },
            ],
        },
        {
            icon: successCases2Svg,
            name: '教育',
            card: [
                {
                    name: '携手考试宝打造职业教育“AI 大脑”',
                    introduction:
                        '考试宝借助千帆平台文心大模型能力，利用自身超大规模用户数据和优质应用场景，实现个性化生成考题、考点及答案解析，新增拍照搜题功能，提供试题解析、AI 学习助手等服务。',
                    benefits: ['30%+|搜题准确率', '98%+|试题解析效率提升', '240%+|营收增长'],
                    bg: require('assets/qf/successCases/bg_anli_jiaoyu01.png').default,
                },
                {
                    name: '携手宁波都市传媒打造“AI作文老师”',
                    introduction:
                        '宁波都市传媒借助千帆平台自主开发了智能作文批改系统，经精调样板间引导训练打造专属大模型，应用于新闻单位征稿审稿场景，为小记者提供投稿作文的评分、详细点评及改进建议。',
                    benefits: ['7000+|累计点评作文', '500+|日均批改作文', '一致好评|来自学生与家长'],
                    bg: require('assets/qf/successCases/bg_anli_jiaoyu02.png').default,
                },
            ],
        },
        {
            icon: successCases3Svg,
            name: '招聘',
            card: [
                {
                    name: '大模型赋能万码优才人才选拔与岗位匹配',
                    introduction:
                        '万码优才通过千帆大模型平台实现 AI 助力人岗精准匹配，提升招聘效率。同时以 AI + 内容为核心，将单一求职服务转变为全周期职场成长服务，推出多项创新功能，重塑求职体验。',
                    benefits: ['提升35%+|日推简历点击率', '提升5倍|信息审核效率', '降低3倍|内容错误率'],
                    bg: require('assets/qf/successCases/bg_anli_zhaopin01.png').default,
                },
                {
                    name: '助力智联招聘实现招聘全流程智能化管理',
                    introduction:
                        '在人岗匹配、Al面试、Al出题等领域，基于智联招聘丰富的行业内容积累，通过调用文心大模型，实现招聘的前、中、后流程全面覆盖提效，同步提升C端求职者、B端招聘者用户体验。',
                    benefits: ['达93%|人岗匹配准确率', '降本至三成|借助模型调优', '千人千“面”|通过AI出题实现'],
                    bg: require('assets/qf/successCases/bg_anli_zhaopin02.png').default,
                },
            ],
        },
        {
            icon: successCases4Svg,
            name: '金融',
            card: [
                {
                    name: '助力太保集团构建智能营销服务体系',
                    introduction:
                        '通过引入千帆AI中台解决方案，太保构建了寿险复盘会质检、客经助手、KYC分析、嗨问保险知识咨询助手等多种AI原生应用。',
                    benefits: ['10万人+|覆盖代理人', '2万通+|日处理经营会议录音', '提升40%+|新契约转化率'],
                    bg: require('assets/qf/successCases/bg_anli_jinrong01.png').default,
                },
                {
                    name: '助力泰康集团搭建知识与大模型应用底座',
                    introduction:
                        '泰康保险集团基于千帆大模型平台搭建了统一的知识与大模型应用底座，面向总子公司提供创新的标准化、高可用、高性能、高精度的AI应用级服务。',
                    benefits: ['9个|办公系统场景接入', '真实模拟|提升员工展业能力', '及时响应|提升代理人服务体验'],
                    bg: require('assets/qf/successCases/bg_anli_jinrong02.png').default,
                },
            ],
        },
        {
            icon: successCases5Svg,
            name: '能源',
            card: [
                {
                    name: '携手国家电网共建电力行业”光明大模型“',
                    introduction:
                        '千帆支持国家电网打造国内首个千亿级多模态电力行业大模型——光明大模型，并为其提供通用基础大模型与工具链平台、相关底层技术等支持，在多个专业领域探索大模型应用。',
                    benefits: ['国内首个|电力行业大模型', '新质生产力|促进能源绿色转型', '典型代表|大模型产业落地'],
                    bg: require('assets/qf/successCases/bg_anli_nengyuan01.png').default,
                },
                {
                    name: '打造矿山行业智能应用 “电博士及数字调度员”',
                    introduction:
                        '上海山源电子科技依托千帆平台打造矿山行业智能应用 “电博士及数字调度员”，“电博士”作为煤矿供电专业的资深贴身助手，可实现陪伴式辅助运维；“数字调度员”作为机器值班员，可实现智能调度指挥。',
                    benefits: ['智能化升级|推动煤矿少人化', '数字化转型|精准高效生产运营'],
                    bg: require('assets/qf/successCases/bg_anli_nengyuan02.png').default,
                },
            ],
        },
        {
            icon: successCases6Svg,
            name: '手机助手',
            card: [
                {
                    name: '赋能三星手机打造多元化AI智能服务',
                    introduction:
                        '三星依托千帆平台针对大模型幻觉、格式输出不稳定等挑战，不断打磨优化效果，全面打造包括：三星输入法升级、智慧办公、Bixby语音助手升级、通话助手等在内的多种AI场景。',
                    benefits: ['多元一体化|Galaxy AI服务', '更人性化|用户使用体验', '新增长点|全新AI手机'],
                    bg: require('assets/qf/successCases/bg_anli_shouji01.png').default,
                },
                {
                    name: '与荣耀联合打造端云协同解决方案',
                    introduction:
                        '同荣耀联合打造端云协同的解决方案，基于文心大模型支持YOYO助手PC端和手机端实现智能创作、会议纪要多文档问答、通用闲聊、角色扮演、情感陪伴等多个智能化能力。',
                    benefits: ['AI手机助手|准确识别意图', '长对话处理|一键生成会议纪要', '智能体生态|多领域合作'],
                    bg: require('assets/qf/successCases/bg_anli_shouji02.png').default,
                },
            ],
        },
    ],
    subTitle: '与全球伙伴携手，深入产业共创价值',
};

export const aIDevelopmentResources = {
    title: '全面的AI开发资源',
    infoArray: [
        {
            title: 'Agent应用开发样例',
            icon: require('assets/qf/aIDevelopmentResources/icon1.png').default,
            description:
                '本文提供快递查询小助手、植物识别小助手、篮球教练来说明使用流程，并提供了一个异步调用示例加速调用流程。',
            link: 'https://cloud.baidu.com/doc/qianfan-docs/s/bm98cr9ds',
            trackInfo: {
                'data-track-category': '千帆官网-全面的AI开发资源',
                'data-track-name': 'Agent应用开发样例',
                'data-track-value': '了解更多',
            },
        },
        {
            title: '在Chatbox中使用大模型',
            icon: require('assets/qf/aIDevelopmentResources/icon2.png').default,
            description:
                'Chatbox 是一个流行的大语言模型的全平台聊天客户端，功能强大、安装简单，可以用它接入各种大语言模型， 实现与 AI 聊天。',
            link: 'https://cloud.baidu.com/doc/qianfan-docs/s/sm96fm3w3?org=bce-doc&repo=qianfan-docs',
            trackInfo: {
                'data-track-category': '千帆官网-全面的AI开发资源',
                'data-track-name': '在Chatbox中使用大模型',
                'data-track-value': '了解更多',
            },
        },
        {
            title: '实现实时语音对话能力',
            icon: require('assets/qf/aIDevelopmentResources/icon3.png').default,
            description:
                '实现实时语音对话功能，支持多种语音音色。通过AppBuilder-SDK将实时语音融入到自己的平台、应用中。',
            link: 'https://cloud.baidu.com/doc/qianfan-docs/s/jm98dle5w',
            trackInfo: {
                'data-track-category': '千帆官网-全面的AI开发资源',
                'data-track-name': '实现实时语音对话能力',
                'data-track-value': '了解更多',
            },
        },
    ],
    nav: [
        {
            title: 'API参考',
            icon: require('assets/qf/aIDevelopmentResources/icon4.png').default,
            subTitle: '详细的API调用文档',
            link: 'https://cloud.baidu.com/doc/qianfan-api/s/3m9b5lqft',
            trackInfo: {
                'data-track-category': '千帆官网-全面的AI开发资源',
                'data-track-name': '',
                'data-track-value': 'API参考',
            },
        },
        {
            title: '开发库',
            icon: require('assets/qf/aIDevelopmentResources/icon5.png').default,
            subTitle: '多语言SDK快速集成',
            link: 'https://cloud.baidu.com/doc/qianfan-docs/s/1m9l6eex1',
            trackInfo: {
                'data-track-category': '千帆官网-全面的AI开发资源',
                'data-track-name': '',
                'data-track-value': '开发库',
            },
        },
        {
            title: '最佳实践',
            icon: require('assets/qf/aIDevelopmentResources/icon6.png').default,
            subTitle: '开发者落地实践指南',
            link: 'https://cloud.baidu.com/qianfan/dev_center/practices',
            trackInfo: {
                'data-track-category': '千帆官网-全面的AI开发资源',
                'data-track-name': '',
                'data-track-value': '最佳实践',
            },
        },
        {
            title: '视频课程',
            icon: require('assets/qf/aIDevelopmentResources/icon7.png').default,
            subTitle: '一站式课程中心',
            link: ' https://cloud.baidu.com/partner/course-center/index.html?type=all&domain=%E7%99%BE%E5%BA%A6%E6%99%BA%E8%83%BD%E4%BA%91%E5%8D%83%E5%B8%86AI%E5%8A%A0%E9%80%9F%E5%99%A8&product=all',
            trackInfo: {
                'data-track-category': '千帆官网-全面的AI开发资源',
                'data-track-name': '',
                'data-track-value': '视频课程',
            },
        },
        {
            title: '千帆社区',
            icon: require('assets/qf/aIDevelopmentResources/icon8.png').default,
            subTitle: '专业高效的交流平台',
            link: 'https://qianfan.cloud.baidu.com/qianfandev',
            trackInfo: {
                'data-track-category': '千帆官网-全面的AI开发资源',
                'data-track-name': '',
                'data-track-value': '千帆社区',
            },
        },
    ],
};

export const serviceMode = {
    title: '多种服务模式',
    left: {
        title: '公有云',
        content: '适合需要快速获取定制大模型服务的企业',
        desc: [
            {
                title: '公共资源服务推理',
                title_small: '公共资源<br/>服务推理',
                context: '超高性价比',
            },
            {
                title: '私有资源服务托管',
                title_small: '私有资源<br/>服务托管',
                context: '保障请求并发',
            },
            {
                title: '7×24 小时工单支持',
                title_small: '7×24 小时<br/>工单支持',
                context: '在线技术服务',
            },
        ],
        btnList: [
            {
                id: 0,
                text: '千帆模型开发平台 ModelBuilder',
                text_small: '千帆模型开发平台 ModelBuilder',
                // link: 'https://qianfan.cloud.baidu.com/modelbuilder',
                link: 'https://console.bce.baidu.com/qianfan/overview',
                trackInfo: {
                    'data-track-category': '千帆官网-多种服务模式',
                    'data-track-name': '公有云',
                    'data-track-value': '千帆模型开发平台ModelBuilder',
                },
            },
            {
                id: 1,
                text: `
                    千帆应用开发平台 AppBuilder    
                `,
                text_small: '千帆应用开发平台 AppBuilder',
                // link: 'https://qianfan.cloud.baidu.com/appbuilder',
                link: 'https://console.bce.baidu.com/ai_apaas/dialogHome',
                trackInfo: {
                    'data-track-category': '千帆官网-多种服务模式',
                    'data-track-name': '公有云',
                    'data-track-value': '大模型应用开发平台AppBuilder',
                },
            },
            {
                id: 2,
                text: '千帆数据智能平台DataBuilder',
                text_small: '千帆数据智能平台 DataBuilder',
                // link: 'https://cloud.baidu.com/product/bml',
                link: 'https://console.bce.baidu.com/edap/#?from=db',
                trackInfo: {
                    'data-track-category': '千帆官网-多种服务模式',
                    'data-track-name': '公有云',
                    'data-track-value': '千帆数据智能平台DataBuilder',
                },
            },
        ],
    },
    right: [
        {
            id: 0,
            title: '私有化',
            desc: '适合对数据私密性和控制性要求较高的企业',
            btn: {
                text: '联系我们',
                link: 'https://cloud.baidu.com/survey/qianfansyhzx.html',
                trackInfo: {
                    'data-track-category': '千帆官网-多种服务模式',
                    'data-track-name': '私有化',
                    'data-track-value': '联系我们',
                },
            },
        },
        {
            id: 1,
            title: '软硬一体',
            desc: '适合需要高可用且开箱即用大模型服务的企业',
            btn: {
                text: '联系我们',
                link: 'https://cloud.baidu.com/survey/qianfansyhzx.html',
                trackInfo: {
                    'data-track-category': '千帆官网-多种服务模式',
                    'data-track-name': '软硬一体',
                    'data-track-value': '联系我们',
                },
            },
        },
    ],
};

export const largeModelEcosystemService = {
    title: '更多大模型生态服务',
    cardItems: [
        {
            id: 1,
            title: 'AI开放平台',
            desc: '提供丰富领先的AI基础能力，助力企业高效构建上层智能化业务应用',
            href: 'https://ai.baidu.com',
            hrefText: '前去了解',
            trackInfo: {
                'data-track-category': '千帆官网-更多大模型生态服务',
                'data-track-name': 'AI开放平台',
                'data-track-value': '前去了解',
            },
        },
        // {
        //     id: 2,
        //     title: 'AI速搭',
        //     desc: 'AI速搭融合大模型，让应用开发过程更简单，开发的应用更智能',
        //     href: 'https://aisuda.baidu.com/',
        //     hrefText: '前去了解',
        //     trackInfo: {
        //         'data-track-category': '千帆官网-更多大模型生态服务',
        //         'data-track-name': 'AI速搭',
        //         'data-track-value': '前去了解',
        //     },
        // },
        {
            id: 3,
            title: '增值服务',
            desc: '提供全栈的大模型服务，帮助企业实现AI应用落地与业务收益',
            href: 'https://cloud.baidu.com/product/llmservice.html',
            hrefText: '前去了解',
            trackInfo: {
                'data-track-category': '千帆官网-更多大模型生态服务',
                'data-track-name': '增值服务',
                'data-track-value': '前去了解',
            },
        },
        {
            id: 4,
            title: '数据服务',
            desc: '提供一体化AI数据服务，加速AI原生应用的研发与持续优化',
            href: 'https://cloud.baidu.com/product/dcs.html',
            hrefText: '前去了解',
            trackInfo: {
                'data-track-category': '千帆官网-更多大模型生态服务',
                'data-track-name': '数据服务',
                'data-track-value': '前去了解',
            },
        },
    ],
};

export const bottomBanner = {
    title: '百度千帆·千帆竞发·智能领航',
    title_small: '百度千帆<br/>千帆竞发·智能领航',
    context: '以Agent为核心的一站式企业级大模型服务平台',
    btnText: '联系我们',
    link: 'https://cloud.baidu.com/survey/modelbuilder-product.html',
    trackInfo: {
        'data-track-category': '千帆官网-底部通栏',
        'data-track-name': '百度千帆·千帆竞发·智能领航',
        'data-track-value': '联系我们',
    },
};
